// src/components/features/Elevation/components/ElevationStep7Material.jsx
// Material Selection — swipe-style selection (folder "4.Material selection"
// me "Radio" naam nahi tha, isliye swipe UI use kiya)

import ElevationSwipeStep from "./shared/ElevationSwipeStep";
import { MATERIAL_IMAGES } from "../../../../assets/Elevation/elevationAssets";

export default function ElevationStep7Material(props) {
  return (
    <ElevationSwipeStep
      {...props}
      title="Material Selection"
      subtitle="Swipe through exterior material finishes and pick what you like"
      items={MATERIAL_IMAGES}
      selectedFieldKey="elevationMaterial"
      likedFieldKey="elevationLikedMaterial"
    />
  );
}
